import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import css from './AdDescription.desktop.scss';
import { FormattedMessage as Translation } from 'react-intl';
import withReplyRestriction from 'HOCs/withReplyRestriction/withReplyRestriction';
export class AdDescription extends React.PureComponent {
    static propTypes = {
        description: PropTypes.string.isRequired
    }

    render() {
        const { description } = this.props;
        const descriptions = description.split('\n');

        return (
            <div className={ css.wrapper } data-aut-id="descriptionDetails">
                <div className={ css.descriptionContainer }>
                    <h4 data-aut-id="itemDescriptonTitle" className={ css.heading }>
                        {<Translation id="description" />}
                    </h4>
                    <div className={ css.separator } />
                    {
                        descriptions.map((description, index) => (
                            <div
                                key={ `${description}-${index}` }
                                className={ description.trim().length ? undefined : css.lineBreak }
                            >
                                {description}
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    }
}

export default compose(
    withReplyRestriction
)(AdDescription);
